import React, {useState} from 'react';
import Dropzone from 'react-dropzone';
import { MdFileUpload, MdClose } from 'react-icons/md';
import cx from 'classnames';
import { document } from '~/api';
import { Pill } from '~/components';
import { fileUtils } from '~/util';

const FileDrop = ({ files = [], heading, bracketHeading, bracketHeadingClassName, headingClassName, multiple = false, readOnly = false, onChange, onRemove, className, groupClassName }) => {
    const [invalidFiles, setInvalidFiles] = useState([]);

    const handleDrop = async (droppedFiles, rejectedFiles) => {
        let newFiles = await Promise.all(
            droppedFiles.map(addUploadProperties)
        );

        const updatedFiles = multiple
            ? [ ...files, ...newFiles]
            : [...newFiles];

        setInvalidFiles(rejectedFiles.map(x => x.file.name));
        
        onChange(updatedFiles);
        
    };

    const addUploadProperties = async (file) => {
        const apiResponse = await document.getUploadLink(file);

        if (apiResponse) {
            const { uploadLink, ...uploadInfo } = apiResponse;
            return {
                file,
                uploadInfo,
                uploadLink
            };
        } else {
            console.error(`Unable to get upload link for file '${file.path}'`);
            return file;
        }
    };

    const rootClasses = cx(
        className,
        'form-input',
        'focus:outline-none',
        'focus:ring-blue-500',
        'focus:ring-2',
        'border',
        'border-gray-200',
        'rounded',
        'bg-gray-50',
        'flex',
        'items-center'
    );

    const headingClasses = cx(
        'form-label',
        headingClassName
    );
    

    const headingBracketClasses = cx(
        'form-label',
        bracketHeadingClassName
    );

    const invalidFileClasses = cx(
        'text-red-400'
    );
    
    return (
        <Dropzone disabled={readOnly} onDrop={handleDrop} multiple={multiple} validator={fileUtils.isValidFileName} >
            {({getRootProps, getInputProps}) => (
                <section className={groupClassName}>
                    <p style={{display:"inline"}} className={headingClasses}>{heading}</p>
                    <p style={{display:"inline"}} className={headingBracketClasses}>{bracketHeading}</p>
                    <div {...getRootProps({ className: rootClasses})}>
                        <input {...getInputProps()} />
                        {files.length < 1 && <p className="text-gray-410 ml-4">Select File...</p> }
                        
                        {files.length > 0 && files.map(({ file }, index) => (
                            file ?
                                <Pill key={`${file.path}-${index}`} bgColor='white' className=" flex items-center my-2 text-sm filter drop-shadow-md ml-4">
                                    {file ? file.path : ''}
                                    <MdClose size='1.25rem' className="ml-1 z-20" onClick={e => {
                                        e.stopPropagation();
                                        onRemove(files[index], index);
                                    }}/>
                                </Pill>
                                :
                                ''
                        ))}
                        <MdFileUpload className="text-gray-410 ml-auto mr-4" size="1.425rem" />
                    </div>
                    <p style={{display:"inline"}} className={invalidFileClasses}>{invalidFiles.length > 0 ? `invalid file(s): ` + invalidFiles?.toString() : ''}</p>
                </section>
            )}
        </Dropzone>
    );
};

export default FileDrop;